module.exports = __webpack_public_path__ + "static/full-cobble-b19341a6602392a67a214d5395aecfb6.jpg";